import gql from "graphql-tag";

export default gql`
  query getBasket {
    basket {
      id
      remainingTime
      totalPrice
      productCount
      updatedAt
      totalSaving
      totalPricePlusShipping
      isAlma
      basketPromoCode {
        code
        value
      }
      basketSales {
        basketProducts {
          basketProductId
          productId
          price
          totalPrice
          totalEcoTax
          totalPublicPrice
          productCount
          quantityMax
          size
          product {
            id
            groupId
            title
            publicPrice
            sellPrice
            appliedPrice
            ecoParticipation
            discountPercentage
            brandDatas {
              name
            }
            sizeDatas {
              productId
              size
              stock
              maxQuantity
              sellPrice
              publicPrice
            }
            imagesDatas {
              urlListPage
            }
          }
        }
        sale {
          id
          name
          minimumDeliveryDate
          maximumDeliveryDate
          productDeliveryDate
          promoMulti
          promoCategory
          saleArea
        }
      }
    }
  }
`;
